import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {map} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LeaderboardService {
  leader_board = environment.baseHref+environment.leader_board_url;
  referral_code = environment.baseHref+environment.referral_code_url;
  constructor(private http: HttpClient) { }
  getAllUserAccounts(page :any,perPage:any){
    const url = `${this.leader_board}`;
    return this.http.get<any>(url ,{
        params: {
            perPage: perPage.toString(),
            page: page.toString()
        }
    })
        .pipe(
            map(response => {
              if (response) {
                return response;
              } else {
                  return [];
              }
            })
        );
  }
    getReferralCode(username:any){
        const url = `${this.referral_code}/${username}`;
        const params = new HttpParams().set('username', username);
        return this.http.get<any>(url ,{ params })
            .pipe(
                map(response => {
                    if (response) {
                        return response;
                    } else {
                        return [];
                    }
                })
            );
    }
}
